import type { ActivitySurface } from './activity.model'

/**
 * Route `data` marking an Editor screen the tracker is active on (typed, so a typo fails `tsc`).
 *
 * `{ shortcuts: false }` marks a screen of the surface that handles none of its
 * shortcuts (the Inspections project list, which shares `group_review` with the
 * review screen): there no key counts as a shortcut — no key frame, no
 * `shortcutKeys` tick count, no `shortcut.ignored` — so the list cannot inflate
 * the surface's friction.
 */
export const activityRouteData = (surface: Exclude<ActivitySurface, 'app'>, opts: { shortcuts?: false } = {}) =>
  opts.shortcuts === false ? { activitySurface: surface, activityShortcuts: false } : { activitySurface: surface }
